module.exports = __webpack_public_path__ + "media/images/banner04-932a544a8c09ee81c8e213d4d2ed8485.webp";